import { PRIMARY_BLUE, WHITE } from '~/Constants/Colors.constants';
import { makeStyles } from '~/UIKit/Style';

export const useStyles = makeStyles((theme) => ({
  card: {
    width: '100%',
    backgroundColor: `${WHITE}`,
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(3),
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    marginBottom: '25px',
    [theme.breakpoints.down('md')]: {
      height: 'auto',
      width: '95%',
      margin: '8px 16px',
    },
  },
  logo: {
    width: 54,
    marginRight: theme.spacing(2),
    alignSelf: 'flex-start',
    marginTop: '20px',
    [theme.breakpoints.up('sm')]: {
      alignSelf: 'initial',
      marginTop: 'initial',
    },
  },
  content: {
    flex: 1,
    paddingRight: '100px',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column',
      paddingRight: '10px',
      paddingLeft: '0',
    },
  },
  title: {
    marginBottom: theme.spacing(1),
  },
  button: {
    backgroundColor: `${PRIMARY_BLUE}`,
    color: 'white',
    fontSize: '15px',
    borderRadius: '3px',
    lineHeight: '19px',
    padding: '10px 20px',
    fontWeight: 'bold',
    textDecoration: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  buttonWhite: {
    backgroundColor: `${WHITE}`,
    color: `${PRIMARY_BLUE}`,
    fontSize: '15px',
    borderRadius: '3px',
    border: `1px solid ${PRIMARY_BLUE}`,
    lineHeight: '19px',
    padding: '10px 20px',
    fontWeight: 'bold',
    textDecoration: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  buttonResponsive: {
    display: 'none',
    textAlign: 'center',
    backgroundColor: `${PRIMARY_BLUE}`,
    color: 'white',
    fontSize: '15px',
    borderRadius: '3px',
    lineHeight: '19px',
    padding: '10px 20px',
    maxWidth: '200px',
    marginTop: '20px',
    fontWeight: 'bold',
    textDecoration: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'block',
    },
  },
  buttonResponsiveWhite: {
    display: 'none',
    textAlign: 'center',
    backgroundColor: `${WHITE}`,
    color: `${PRIMARY_BLUE}`,
    border: `1px solid ${PRIMARY_BLUE}`,
    fontSize: '15px',
    borderRadius: '3px',
    lineHeight: '19px',
    padding: '10px 20px',
    maxWidth: '200px',
    marginTop: '20px',
    fontWeight: 'bold',
    textDecoration: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'block',
    },
  },
  integrationDescription: {
    fontSize: '15px',
  },
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
  underlineNone: {
    textDecoration: 'none',
  },
}));
